import { COMPONENT_IDS } from "../storage2ComponentIDs";
class InsertComponent {
    constructor({ stabilityPoints, holesOccupied }) {
        this.typeId = InsertComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
        this.stabilityPoints = stabilityPoints;
        this.holesOccupied = holesOccupied;
    }
    eq() {
        return true;
    }
}
InsertComponent.id = COMPONENT_IDS.INSERT;
export default InsertComponent;
